var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("p", { domProps: { innerHTML: _vm._s(_vm.routeText) } }),
      _vm._v(" "),
      _vm.submitError
        ? _c("b-alert", { attrs: { show: "", variant: "danger" } }, [
            _vm._v(_vm._s(_vm.submitError))
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.code,
            expression: "code"
          }
        ],
        staticClass: "form-control mb-4",
        attrs: {
          type: "text",
          placeholder: _vm.$t(
            "base.errors.unauthozed-travel-error-page.new-code"
          )
        },
        domProps: { value: _vm.code },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.code = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _vm.isGenericCode
        ? _c(
            "div",
            [
              _c("base-input", {
                attrs: {
                  placeholder: _vm.$t(
                    "base.errors.unauthozed-travel-error-page.new-reservation-number"
                  )
                },
                model: {
                  value: _vm.reservationNumber,
                  callback: function($$v) {
                    _vm.reservationNumber = $$v
                  },
                  expression: "reservationNumber"
                }
              }),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "6" } },
                    [
                      _c("base-datepicker", {
                        attrs: {
                          placeholder: _vm.$t(
                            "base.errors.unauthozed-travel-error-page.new-start-date"
                          )
                        },
                        model: {
                          value: _vm.startDate,
                          callback: function($$v) {
                            _vm.startDate = $$v
                          },
                          expression: "startDate"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "6" } },
                    [
                      _c("base-datepicker", {
                        attrs: {
                          placeholder: _vm.$t(
                            "base.errors.unauthozed-travel-error-page.new-end-date"
                          )
                        },
                        model: {
                          value: _vm.endDate,
                          callback: function($$v) {
                            _vm.endDate = $$v
                          },
                          expression: "endDate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("base-button", { on: { click: _vm.send } }, [
        _vm._v(_vm._s(_vm.$t("continue")))
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-778daab6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-778daab6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/errors/UnauthorizedTravelErrorPage.vue
// module id = 3719
// module chunks = 90